import StarMini from "./star-mini.svg";

export default StarMini;
